import { Spin } from "antd";
import { useState, useEffect } from "react";

const ArSectionModal = ({ qrcodeImgPath }) => {
  const [loading, setLoading] = useState(true);
  const [qrUrl, setQrUrl] = useState(null);
  const DisplayContent = [
    "Scan the QR code",
    "with your mobile",
    "and place your product virtually",
    "in your own space.",
  ];

  useEffect(() => {
    const fetchQrCode = async () => {
      setLoading(true);
      try {
        while (!qrcodeImgPath) {
          await new Promise((resolve) => setTimeout(resolve, 500));
        }
        setQrUrl(qrcodeImgPath);
        /* eslint-enable no-await-in-loop */
      } catch (error) {
        console.error("Error fetching QR code:", error);
        setQrUrl(null);
      } finally {
        setLoading(false);
      }
    };

    fetchQrCode();
  }, [qrcodeImgPath]);

  return (
    <div className="arModalWrapper">
      <div className="contentWrapper">
        <div className="leftContent">
          <div className="scanViewText">
            <img src="/view-in-ar-icon.svg" alt="View in AR Icon" />
            <p className="mb-0">Scan to view in AR</p>
          </div>
          <div className="imageContainer">
            {loading ? (
              <Spin className="black-spinner" />
            ) : qrUrl ? (
              <img
                src={qrUrl}
                alt="View in AR QR Code"
                id="arBarcod"
                className="arBarcod"
                width={160}
                height={160}
              />
            ) : (
              <p className="errorText">
                Unable to load QR code. Please try again.
              </p>
            )}
          </div>
        </div>
        <div className="rightContent">
          <div className="min-w-[245px]">
            {DisplayContent?.map((text, index) => (
              <p key={index} className="mb-0">
                {text}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArSectionModal;
